module.exports = __webpack_public_path__ + "static/media/Bathani-Comunicacao-01.e4c7570f.jpg";